/**
 * Records a live call's turns as they are transcribed and archives the whole thing when the call ends
 * (internal wiki page + Brand OS insights on the backend). Fire-and-forget; never blocks the UI.
 */
import { coworkApi } from '@/cowork/omniad/api/coworkApi';

export class CallRecorder {
  private turns: Array<{ role: 'agent' | 'user' | 'room'; text: string; at: string }> = [];
  private startedAt = new Date().toISOString();
  private archived = false;
  /** The call's cowork voice sessions (one per Realtime/ears connection): the archive ends them too. */
  private voiceSessions = new Set<string>();
  private meta: { kind: 'presentation' | 'kickoff' | 'proposal' | 'meeting'; agent: string; title: string; brandId?: string; refId?: string | null; userName?: string | null; context?: string };
  constructor(meta: { kind: 'presentation' | 'kickoff' | 'proposal' | 'meeting'; agent: string; title: string; brandId?: string; refId?: string | null; userName?: string | null; context?: string }) { this.meta = meta; }
  /** Call with FINAL transcripts only. */
  add(role: 'agent' | 'user' | 'room', text: string) { const t = (text || '').trim(); if (t) this.turns.push({ role, text: t, at: new Date().toISOString() }); }
  get count() { return this.turns.length; }
  /** The caller's name, when it arrives with the mint answer (after the recorder was made). */
  setUserName(name: string | null | undefined) { if (name) this.meta = { ...this.meta, userName: name }; }
  /** Name a voice session of this call (from the call's `voiceSessionId`); null is ignored. */
  addVoiceSession(id: string | null | undefined) { if (id) this.voiceSessions.add(id); }
  async archive(): Promise<void> {
    if (this.archived || this.turns.length < 2) return;
    this.archived = true;
    const voiceSessionIds = [...this.voiceSessions];
    try { await coworkApi.calls.archive({ ...this.meta, startedAt: this.startedAt, endedAt: new Date().toISOString(), turns: this.turns, ...(voiceSessionIds.length ? { voiceSessionIds } : {}) }); }
    catch (e) { console.warn('[call-archive] failed:', (e as Error).message); }
  }
}
